// Vendor libraries
import { CommonModule } from '@angular/common';
import * as i0 from "@angular/core";
export class TextEditModule {
}
TextEditModule.ɵfac = function TextEditModule_Factory(t) { return new (t || TextEditModule)(); };
TextEditModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: TextEditModule });
TextEditModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] });
